<template>
  <transition name="modal">
    <div class="photo-modal overlay component" v-if="showLocal" @click="onClickOverlay" ref="overlay">
      <div class="modal-content" v-if="this.albumList.length">
        <UiDataBox :loading="loading" :error="error">
          <i class="close" @click="close" v-shortkey="['esc']" @shortkey="close" v-if="showCloseButton && !loading"></i>

          <a href="#" @click.prevent="goToPreviousPhoto" v-shortkey="['arrowleft']" @shortkey="goToPreviousPhoto" class="prev">
            <i class="ico"></i>
          </a>
          <a href="#" @click.prevent="goToNextPhoto" v-shortkey="['arrowright']" @shortkey="goToNextPhoto" class="next">
            <i class="ico"></i>
          </a>
          <ImgLoader :src="item._src" animated></ImgLoader>
        </UiDataBox>
      </div>

    </div>
  </transition>
</template>

<script>
  import * as photosService from '../../services/photos.service'
  import * as albumsService from '../../services/albums.service'

  import setModelMixin from '../../mixins/setModelMixin'
  import ImgLoader from '../../components/ImgLoader.vue'

  export default {
    name: 'PhotoModal',
    mixins: [setModelMixin],
    components: {
      ImgLoader
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      showCloseButton: {
        type: Boolean,
        default: true
      },
      closeOnOverlay: {
        type: Boolean,
        default: false
      },
      photoId: {
        type: Number
      }
    },
    watch: {
      show: function (newVal) {
        this.showLocal = newVal
      },
      photoId: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchItem()
        }
      }
    },

    data () {
      return {
        showLocal: this.show,
        loading: false,
        error: false,
        item: {
          _src: ''
        }
      }
    },

    computed: {
      albumList () {
        return this.$store.state.currentAlbum.map(item => item.id)
      },
      currentPhotoIndex () {
        return this.albumList.indexOf(this.photoId)
      },
      getPreviousPhotoId () {
        const previousId = this.albumList[this.currentPhotoIndex - 1]
        const lastId = this.albumList[this.albumList.length - 1]
        return previousId || lastId
      },
      getNextPhotoId () {
        const nextId = this.albumList[this.currentPhotoIndex + 1]
        const firstId = this.albumList[0]
        return nextId || firstId
      }
    },

    methods: {
      fetchItem () {
        this.loading = true
        photosService.getById(this.photoId)
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
          }).catch(error => {
            this.error = error.message
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      /**
       * при условии что если юзер перешол по прямой ссылке,
       * например http://localhost:8080/gallery/album/318/photo/59
       * мы сталкиваемся с проблемой что сущьность альбома еще не загружена
       *
       * для решения чего необходимо перед загрузкой сущьности фотографии загрузить сущьность альбома
       * далее по полученному списку фотографий мы сможем определить индекс текущей, слудующей и предудущей фотографий
       * и отобразить необходимые Id в ссылках (next/prev)
       */
      fetchAndInitAlbum () {
        this.loading = true
        albumsService.getById(this.$route.params.albumId)
          .then(response => this.$store.commit('SET_CURRENT_ALBUM', response.data.photos))
          .then(() => this.fetchItem())
          .catch(error => console.log(error))
          .finally(() => { this.loading = false })
      },
      close () {
        this.$emit('close')
      },
      onClickOverlay ($event) {
        if (this.closeOnOverlay && $event && $event.target === this.$refs.overlay) {
          this.close()
        }
      },
      goToPreviousPhoto () {
        this.$router.push({name: 'photo-view', params: {photoId: this.getPreviousPhotoId}})
      },
      goToNextPhoto () {
        this.$router.push({name: 'photo-view', params: {photoId: this.getNextPhotoId}})
      }
    },

    mounted () {
      if (!this.albumList.length) {
        this.fetchAndInitAlbum()
      } else {
        this.fetchItem()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .photo-modal.component.overlay {
    width: 100vw;
    height: 100vh;
    z-index: 100;
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    .modal-content {
      display: flex;
      align-items: center;
      position: relative;
      min-width: 300px;
      min-height: 100px;
      background-color: $color-body;
      /deep/ img {
        max-height: 85vh;
      }
      .prev, .next {
        z-index: 1;
        position: absolute;
        width: 10%;
        min-width: 60px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;

        &:hover {
          transition: all .5s;
          opacity: 1;
        }
      }
      .prev {
        left: 0;
        & > .ico {
          @include arrow-prev;
        }
      }
      .next {
        right: 0;
        & > .ico {
          @include arrow-next;
        }
      }
    }

    .close {
      @include icon-close;
      @include button_base;
      position: fixed;
      top: 15px;
      right: 15px;
      z-index: 10;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/album/PhotoModal.vue